import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import PropTypes from 'prop-types';
import styled from 'styled-components';
import { getRem, wordBreak } from "./../../core";
var ToastContent = styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['withMultipleActions'].includes(prop);
  }
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  box-sizing: border-box;\n  display: flex;\n  flex: 1 1 auto;\n  padding: ", ";\n  padding-bottom: ", ";\n  touch-action: none;\n"])), wordBreak, function (_ref) {
  var theme = _ref.theme;
  return "".concat(theme.size.spacing.large.value, " ").concat(getRem('14px'));
}, function (_ref2) {
  var theme = _ref2.theme,
      withMultipleActions = _ref2.withMultipleActions;
  return withMultipleActions ? 0 : theme.size.spacing.large.value;
});
ToastContent.propTypes = {
  /** Any content inserted between component tags */
  children: PropTypes.node.isRequired,

  /** If true sets padding-bottom to 0 */
  withMultipleActions: PropTypes.bool
};
ToastContent.defaultProps = {
  withMultipleActions: false
};
export { ToastContent };